import { render, staticRenderFns } from "./FacEdit.vue?vue&type=template&id=a60b27e4"
import script from "./FacEdit.vue?vue&type=script&lang=js"
export * from "./FacEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports